import { NocfoTheme } from '../styled'
import logo from '@assets/nocfo/wordmark-dark-colored.svg'
import logoLight from '@assets/nocfo/wordmark-light-colored.svg'
import logoMark from '@assets/nocfo/mark.svg'

export const theme: NocfoTheme = {
  colors: {
    neutralBlack: '#000000',
    neutralGray: '#EEF1F4',
    neutralWhite: '#FFFFFF',
    iconGray: '#73808C',
    iconGrayDark: '#3B4A57',
    mutedYellow: '#F7CC7A',
    primary: '#1b98f5',
    info: '#1b98f5',
    success: '#39d273',
    error: '#f50d05',
    warning: '#f5a91b',
    AIPurple: '#c000ec',
    menuBg: '#031e33',
    metalGray: '#3e444e',
    backdrop: '#435a6f66',
    defaultHover: '#fafbfc',
    dashboardPos: '#031e33',
    dashboardNeg: '#ff576f',
    dashboardExtra1: '#167ac4',
    dashboardExtra2: '#105b93',
    ifBlue: '#0054f0',
    kraviaOrange: '#ff5e29',
    borderSoft: '#E4E8EC',
    borderStrong: '#CFD6DD'
  },
  dashboard: {
    surfaceSubtle: '#F4F6FA',
    gridLine: '#F1F4F7',
    divider: '#DCE2E8',
    infoTint: '#E3F2FE',
    infoSoft: '#C7E6FE',
    infoMid: '#7CC7FA',
    infoDeep: '#1580D4',
    onNavyLabel: '#9BD3FF',
    onNavyAxis: '#8FA3B5',
    onNavyMuted: '#A9B4BF',
    textSubtle: '#556370',
    positive: '#1E9E5A',
    positiveTint: '#E7F8EF',
    caution: '#B26A00',
    cautionTint: '#FEF3E2',
    critical: '#C40D07',
    criticalTint: '#FDEAE9'
  },
  luca: {
    navy: '#031E33',
    deepBlue: '#0B3D62',
    blue: '#1B98F5',
    sky: '#70C2FF',
    mist: '#F5F8FB',
    mistBorder: '#DCE6EF',
    tint: '#E4EDF5',
    tintBorder: '#C6D8E8',
    textMuted: '#5E6878',
    fontDisplay: "'Cormorant Garamond', Georgia, serif"
  },
  typography: {
    fontFamily: {
      montserrat: 'Montserrat, sans-serif'
    }
  },
  spacing: {
    none: 0,
    xxxs: 0.09,
    xxs: 0.18,
    xs: 0.4,
    sm: 0.6,
    md: 0.85,
    lg: 1.25,
    xl: 1.7,
    xxl: 2.5
  },
  fontSize: {
    xxs: 0.5625,
    xs: 0.75,
    sm: 0.8125,
    md: 0.9375,
    lg: 1.0625,
    xl: 1.3125,
    xxl: 1.5625,
    px85: 0.53125,
    px10: 0.625,
    px105: 0.65625,
    px11: 0.6875,
    px115: 0.71875,
    px125: 0.78125,
    px135: 0.84375,
    px14: 0.875,
    px145: 0.90625,
    px155: 0.96875,
    px31: 1.9375
  },
  borderRadius: {
    sm: 0.5,
    md: 0.85,
    lg: 1.5
  },
  iconSize: {
    xxs: 0.8,
    xs: 1,
    sm: 1.5,
    md: 2,
    lg: 2.5
  },
  iconTile: {
    size: 2.75
  },
  breakpoint: {
    xs: '20em',
    sm: '23.4375em',
    md: '48em',
    lg: '64em',
    xl: '80em',
    xxl: '100em'
  },
  shadow: {
    md: '0px 2px 10px 0px rgba(0, 0, 0, 0.1)',
    card: '0 2px 13px rgba(27, 31, 35, 0.15)',
    soft: '0 2px 10px rgba(3, 30, 51, 0.06)'
  },
  brandUrl: 'https://nocfo.io',
  assets: {
    logo,
    logoLight,
    logoMark
  }
}

export default theme
